<template>
  <div class="mt-15 container card_container">
    <b-container class="bv-example-row">
      <b-card bg-variant="light">
        <h3 class="mb-5 titolo-success"><i class="fas fa-check-double"></i> Pagamento Riuscito</h3>
        <b-container class="bv-example-row pt-lg-6">
          <b-row class="text-center">
            <b-col sm class="mb-7">
              <strong><span class="text-center">Pagamento avvenuto correttamente</span></strong>
            </b-col>
          </b-row>
        </b-container>
      </b-card>
    </b-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tokenLogin: null,
    };
  },
  mounted: function () {
    let me = this;
    me.tokenLogin = sessionStorage.getItem("loginData");
    me.controlloToken();
  },
  methods: {
    controlloToken() {
      let me = this;
      if (me.tokenLogin) {
        setTimeout(() => this.$router.push({ path: "/storicopagamenti" }), 5000);
      }
    },
  },
};
</script>
